<template>
  <div
    class="bg-white rounded md:rounded-full shadow-custom py-4 px-8 gap-8 flex items-center w-full flex-col md:flex-row"
    :class="{
      'justify-between': isAnnualPodium,
      'justify-center': !isAnnualPodium,
    }"
  >
    <GoodMorningBaby />
    <ProgressBarWithLegend
      v-if="!isAnnualPodium"
      :dataSend="dataSend"
      :finalDate="finalDate"
      :metaTotalDivisao="metaTotalDivisao"
      :isAnnualPodium="isAnnualPodium"
      :isLoading="isLoading"
    />
    <div>
      <Calendar
        :initialDate="initialDate"
        :finalDate="finalDate"
        :isAnnualPodium="isAnnualPodium"
      />
    </div>
  </div>
</template>

<script>
import Calendar from './Calendar.vue';
import GoodMorningBaby from './GoodMorningBaby.vue';
import ProgressBarWithLegend from './ProgressBarWithLegend.vue';

export default {
  name: 'PainelComercialHeader',
  components: { GoodMorningBaby, ProgressBarWithLegend, Calendar },
  data() {
    return {};
  },
  props: [
    'finalDate',
    'initialDate',
    'dataSend',
    'isAnnualPodium',
    'metaTotalDivisao',
    'isLoading',
  ],
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.shadow-custom {
  box-shadow: -5px 0 5px 0 rgba(0, 0, 0, 0.027),
    5px 0 5px 0 rgba(0, 0, 0, 0.027), 0 -5px 5px 0 rgba(0, 0, 0, 0.027),
    0 5px 5px 0 rgba(0, 0, 0, 0.027);
}
</style>
